import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const MailIcon = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 16 16" fill="none" title={t`Mail`} {...props}>
      <Path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M13.5 3.25c.69 0 1.25.56 1.25 1.25v7c0 .69-.56 1.25-1.25 1.25h-11c-.69 0-1.25-.56-1.25-1.25v-7c0-.69.56-1.25 1.25-1.25h11Z"
      />
      <Path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M1.5 5 8 9l6.5-4"
      />
    </Icon>
  );
};
